import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCurateOutletAppProviders = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.AppProviders />,
        });
      })
      .catch(reject);
  });
});

export const LazyCurateOutletAppProviders = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCurateOutletAppProviders />
    </Suspense>
  );
};
